window.defTrackingInformation = $.Deferred();
window.defGeoIP = $.Deferred();
window.defFormLogic = $.Deferred();
